import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/name/list`;

export const ROUTE: RouteDefinition = `${baseRoute}/name/list`;

export const URL = (): RouteDefinition => `${baseRoute}/name/list`;
